/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { Address } from './Address';
import type { ClientTherapist } from './ClientTherapist';
import type { CustomFieldData } from './CustomFieldData';
export type Client = {
    /**
     * True when the client has a portal (Keycloak) account
     */
    hasAccount: boolean;
    createdAt: string;
    updatedAt: string;
    lastAppointmentDate?: string | null;
    /**
     * Average days between appointments
     */
    averageAppointmentIntervalDays?: number | null;
    /**
     * Therapist who owns this client (only included when fetching across managed users)
     */
    therapist?: ClientTherapist | null;
    id: number;
    firstName: string;
    lastName: string;
    gender: Client.gender;
    email: string | null;
    phoneNumber: string | null;
    birthdate: string | null;
    address: Address | null;
    status: Client.status;
    notes: string;
    isActive: boolean;
    deleted: boolean;
    deletionRequestedByClient: boolean;
    archived: boolean;
    customFieldData: Array<CustomFieldData>;
};
export namespace Client {
    export enum gender {
        MALE = 'male',
        FEMALE = 'female',
        DIVERSE = 'diverse',
        NOT_SET = 'not_set',
        DELETED = 'deleted',
    }
    export enum status {
        NEW = 'new',
        CLIENT = 'client',
        WITHOUT_ACCOUNT = 'without-account',
        WITH_ACCOUNT = 'with-account',
        ACTIVE = 'active',
        INACTIVE = 'inactive',
    }
}

